// // Scroll Animation
// const elements = document.querySelectorAll(".scroll-animation");
// function checkScroll() {
//     elements.forEach(el => {
//         const rect = el.getBoundingClientRect();
//         if (rect.top < window.innerHeight * 0.85) {
//             el.classList.add("visible");
//         }
//     });
// }
// window.addEventListener("scroll", checkScroll);
// checkScroll();

var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
        if (entry.isIntersecting) {
            $(entry.target).addClass("visible");
        }
    });
});

$(".scroll-animation").each(function () {
    observer.observe(this);
});

var observer2 = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
        if (entry.isIntersecting) {
            $(entry.target).addClass("is-show");
        }
    });
});

$(".fade-in-scroll").each(function () {
    observer2.observe(this);
});



// Thumb Animation
const thumbItems = document.querySelectorAll(".thumb-animate");
function checkVisibility() {
    thumbItems.forEach(el => {
        const rect = el.getBoundingClientRect();
        const elementHeight = rect.height;
        const visibleHeight = Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top);

        if (visibleHeight >= elementHeight * 0.4) {
            el.classList.add("in-view");
        }
    });
}
window.addEventListener("scroll", checkVisibility);
checkVisibility();



// Reveile Animation
function singleScrollReveal(className = ".reveal-group", visibleOffset = 150, delay = 300) {
    function runReveal() {
        $(className).each(function () {
            var $parent = $(this);
            var windowHeight = $(window).height();
            var elementTop = $parent.offset().top - $(window).scrollTop();

            if (elementTop < windowHeight - visibleOffset) {
                $parent.children().each(function (index) {
                    var $ele = $(this);
                    setTimeout(function () {
                        $ele.addClass("insight");
                    }, index * delay);
                });
            }
        });
    }
    $(window).on("scroll", runReveal);
    $(document).ready(runReveal);
}
singleScrollReveal();







// $(document).ready(function () {
//     function checkVisibility() {
//         $('.fade-in-scroll').each(function () {
//             var elementTop = $(this).offset().top;
//             var viewportBottom = $(window).scrollTop() + $(window).height();
//             if (elementTop < viewportBottom - 1) {
//                 $(this).addClass('is-show');
//             }
//         });
//     }
//     checkVisibility();
//     $(window).on('scroll', function () {
//         checkVisibility();
//     });

// });






function headerSticky() {
    let lastScrollTop = 0;
    const header = document.querySelector('.header');
    if (!header) return;
    window.addEventListener('scroll', function () {
        const currentScroll = window.scrollY;
        if (currentScroll > 100) header.classList.add('header__inner_hove-active');
        else header.classList.remove('header__inner_hove-active');
        if (currentScroll <= 100) {
            header.style.transform = 'translateY(0)';
        }
        else if (currentScroll < lastScrollTop) {
            header.style.transform = 'translateY(0)';
        }
        else {
            header.style.transform = 'translateY(-150%)';
        }
        lastScrollTop = currentScroll;
    });
}

headerSticky();




if ($(Window).width() < 768) {
    $(".footer__navigation-title").click(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass("active");
            $(this).next(".footer__navigation-content").slideUp();
        } else {
            $(".footer__navigation-content").slideUp();
            $(".footer__navigation-title").removeClass("active");
            $(this).addClass("active");
            $(this).next(".footer__navigation-content").slideDown();
        }
    })
}



// Start Featured Products Slider MObile

if ($(Window).width() < 768) {
    $('.featured-products__content').slick({
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    });
}

// End Featured Products Slider MObile

// Start Review Slider

$('.review__items').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
    ]
});

$('.review__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.review__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});

// End Review Slider


$('.customer-review__cards').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
            }
        },
    ]
});

$('.customer-review__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});
$('.customer-review__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});





$(".menu-drawer__has-menu").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".menu-drawer__has-menu-items").slideUp();
    } else {
        $(".menu-drawer__has-menu-items").slideUp();
        $(".menu-drawer__has-menu").removeClass("active");
        $(this).addClass("active");
        $(this).next(".menu-drawer__has-menu-items").slideDown();
    }
})



$(".header__mobi-menu").on("click", function () {
    $("body").addClass("menu-drawer-open");
    $(".menu-drawer__nav-list").removeClass("show");
    $(".menu-drawer__nav-list").each(function (index) {
        let item = $(this);
        setTimeout(function () {
            item.addClass("show");
        }, index * 120);
    });
});

$(".menu-drawer__close, .overlay").on("click", function () {
    $("body").removeClass("menu-drawer-open");
    $(".menu-drawer__nav-list").removeClass("show");
});










// $('.product__big-items').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: false,
//     fade: false,
//     dots: false,
//     adaptiveHeight: true,
//     asNavFor: '.product__small-items',
//     responsive: [
//         {
//             breakpoint: 768,
//             settings: {
//                 dots: true,
//             }
//         },
//     ]
// });
// $('.product__small-items').slick({
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     asNavFor: '.product__big-items',
//     centerMode: false,
//     focusOnSelect: true,
//     arrows: false,
//     vertical: true,
// });





function handleLoading($btn, duration = 1200) {
    const $parent = $btn.parent();
    clearTimeout($parent.data("loadingTimeout"));
    $parent.addClass("loading");
    const timeoutId = setTimeout(function () {
        $parent.removeClass("loading");
    }, duration);
    $parent.data("loadingTimeout", timeoutId);
}
$(document).on("click", ".click-loading", function (e) {
    e.preventDefault();
    handleLoading($(this));
});







$('.interessant-product__items').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
            }
        },
    ]
});

$('.interessant-product__arrow-left').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.interessant-product__arrow-right').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});




let productImages = [];
$('.product__big-item').each(function () {
    productImages.push({
        src: $(this).find('img').attr('src'),
    });
});
$('.product__big-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    dots: false,
    adaptiveHeight: true,
    asNavFor: '.product__small-items',
    responsive: [
        {
            breakpoint: 768,
            settings: {
                dots: true,
            }
        },
    ]
});
$('.product__small-items').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.product__big-items',
    centerMode: false,
    focusOnSelect: true,
    arrows: false,
    vertical: true,
});
$.each(productImages, function (index, item) {
    $('.product-modal__gallery').append(`
        <div class="product-modal__item">
            <img src="${item.src}" alt="">
        </div>
    `);
    if (index < 3) {
        $('.product-modal__thumbs').append(`
            <div class="product-modal__thumb">
                <img src="${item.src}" alt="">
            </div>
        `);
    }
});
$('.product-modal__gallery').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    infinite: false,
    prevArrow: `
        <button type="button" class="product-modal__arrow product-modal__arrow-prev">
            <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.0006 21.1422C0.922036 10.0965 9.81212 1.07901 20.8578 1.00044C31.9036 0.921876 40.921 9.81196 40.9996 20.8577C41.0782 31.9034 32.1881 40.9209 21.1424 40.9994C10.0966 41.078 1.07917 32.1879 1.0006 21.1422Z" fill="white" />
                <path d="M28.9999 20.943L13.0003 21.0568M19.9503 14.0072L13.0003 21.0568L20.0499 28.0069M20.8578 1.00044C9.81212 1.07901 0.922035 10.0965 1.0006 21.1422C1.07917 32.1879 10.0966 41.078 21.1424 40.9994C32.1881 40.9209 41.0782 31.9034 40.9996 20.8577C40.921 9.81196 31.9036 0.921875 20.8578 1.00044Z" stroke="#4B4A4A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>
    `,
    nextArrow: `
        <button type="button" class="product-modal__arrow product-modal__arrow-next">
            <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M40.9985 21.2389C40.8665 32.2841 31.8062 41.1305 20.761 40.9985C9.71575 40.8666 0.869355 31.8062 1.00131 20.761C1.13327 9.71581 10.1936 0.869417 21.2388 1.00137C32.284 1.13333 41.1304 10.1937 40.9985 21.2389Z" fill="white" />
                <path d="M13.0005 20.9044L28.9993 21.0955M21.9162 28.0114L28.9993 21.0955L22.0834 14.0124M20.761 40.9985C31.8062 41.1305 40.8665 32.2841 40.9985 21.2389C41.1304 10.1937 32.284 1.13333 21.2388 1.00137C10.1936 0.869417 1.13327 9.71581 1.00131 20.761C0.869355 31.8062 9.71575 40.8666 20.761 40.9985Z" stroke="#4B4A4A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>
    `
});
$('.product-modal__thumbs').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    focusOnSelect: true,
    arrows: false,
    infinite: false,
    rows: 0,
});
$('.product-modal__thumbs').on('click', '.slick-slide', function () {
    let thumbIndex = $(this).data('slick-index');
    $('.product-modal__gallery').slick('slickGoTo', thumbIndex, true);
});
$('.product-modal__gallery').on('afterChange', function (event, slick, currentSlide) {
    $('.product-modal__thumbs .slick-slide').removeClass('slick-current');
    $('.product-modal__thumbs .slick-slide[data-slick-index="' + currentSlide + '"]').addClass('slick-current');
});
$('.product__big-items').on('click', '.product__big-item', function () {
    let currentIndex = $(this).closest('.slick-slide').data('slick-index');
    if (currentIndex === undefined || currentIndex === null) {
        currentIndex = 0;
    }
    $('.product-modal, body').addClass('product-modal-open');
    setTimeout(function () {
        $('.product-modal__gallery').slick('setPosition');
        $('.product-modal__gallery').slick('slickGoTo', currentIndex, true);

        $('.product-modal__thumbs .slick-slide').removeClass('slick-current');
        $('.product-modal__thumbs .slick-slide[data-slick-index="' + currentIndex + '"]').addClass('slick-current');
    }, 50);
});
$('.product-modal__close, .product-modal__overlay, .overlay').on('click', function () {
    $('.product-modal, body').removeClass('product-modal-open');
});




// const btn = document.querySelector('.product-details-info__btn');
// const textContent = document.querySelector('.product-details-info__bot-content');
// btn.addEventListener('click', function (e) {
//     e.preventDefault();
//     textContent.classList.toggle('expanded');
//     if (textContent.classList.contains('expanded')) {
//         this.textContent = 'LEES MINDER';
//     } else {
//         this.textContent = 'LEES MEER';
//     }
// });













$(function () {
    function customDropdown(wrapper, select, option) {
        $(document).on('click', select, function (e) {
            e.stopPropagation();
            const $dropdown = $(this).siblings(option);
            $(option)
                .not($dropdown)
                .stop(true, true)
                .slideUp(250);
            $dropdown.stop(true, true).slideToggle(250);
        });
        $(document).on('click', `${option} li`, function (e) {
            e.stopPropagation();
            $(this)
                .closest(wrapper)
                .find(select)
                .text($(this).text());
            $(this)
                .closest(option)
                .stop(true, true)
                .slideUp(250);
        });
    }
    customDropdown(
        '.collection-product__topbar__dropdown',
        '.collection-product__topbar-dropdown-select',
        '.collection-product__topbar-dropdown-option'
    );
    customDropdown(
        '.collection-product__bottom-dropdown',
        '.collection-product__bottom-dropdown-select',
        '.collection-product__bottom-dropdown-option'
    );
    $(document).on('click', function () {
        $('.collection-product__topbar-dropdown-option, .collection-product__bottom-dropdown-option')
            .stop(true, true)
            .slideUp(250);
    });
});




$('.collection-product__heading-less-more-btn').on('click', function () {
    const $text = $(this).siblings('p');
    $text.toggleClass('active');
    if ($text.hasClass('active')) {
        $(this).text('Lees minder');
    } else {
        $(this).text('Lees meer');
    }
});




$(document).on('click', '.collection-product__description-btn', function () {
  $(this)
    .siblings('.collection-product__description-content')
    .toggleClass('active');

  $(this).text(function (_, text) {
    return $.trim(text) === 'Lees meer' ? 'Lees minder' : 'Lees meer';
  });
});
// $(function () {
//     $('.collection-product__description').each(function () {
//         const $box = $(this);
//         const $content = $box.find('.collection-product__description-content');
//         const $first = $box.find('p:eq(0)');
//         const $second = $box.find('p:eq(1)');
//         const $btn = $box.find('.collection-product__description-btn');
//         function initDescription() {
//             $first.stop(true, true).removeAttr('style');
//             $second.stop(true, true).removeAttr('style').show();
//             $box.removeClass('active');
//             $content.removeClass('active');
//             $btn.text('Lees meer');
//             if ($(window).width() >= 992) {
//                 const lineHeight = parseFloat($second.css('line-height'));
//                 const collapsedHeight = lineHeight * 3;
//                 $second.css({
//                     maxHeight: collapsedHeight,
//                     overflow: 'hidden'
//                 });
//             } else {
//                 const lineHeight = parseFloat($first.css('line-height'));
//                 const collapsedHeight = lineHeight * 4;
//                 $first.css({
//                     maxHeight: collapsedHeight,
//                     overflow: 'hidden'
//                 });
//                 $second.hide();
//             }
//         }
//         initDescription();
//         $(window).on('resize', function () {
//             initDescription();
//         });
//         $btn.on('click', function () {
//             if ($(window).width() >= 992) {
//                 const expandedHeight = $second[0].scrollHeight;
//                 const collapsedHeight = parseFloat($second.css('line-height')) * 3;
//                 if ($box.hasClass('active')) {
//                     $second.stop(true, true).animate({
//                         maxHeight: collapsedHeight
//                     }, 300);
//                     $content.removeClass('active');
//                     $box.removeClass('active');
//                     $btn.text('Lees meer');
//                 } else {
//                     $second.stop(true, true).animate({
//                         maxHeight: expandedHeight
//                     }, 300);
//                     $content.addClass('active');
//                     $box.addClass('active');
//                     $btn.text('Lees minder');
//                 }
//             } else {
//                 const expandedHeight = $first[0].scrollHeight;
//                 const collapsedHeight = parseFloat($first.css('line-height')) * 4;
//                 if ($box.hasClass('active')) {
//                     $second.stop(true, true).slideUp(300);
//                     $first.stop(true, true).animate({
//                         maxHeight: collapsedHeight
//                     }, 300);
//                     $box.removeClass('active');
//                     $btn.text('Lees meer');
//                 } else {
//                     $first.stop(true, true).animate({
//                         maxHeight: expandedHeight
//                     }, 300);
//                     $second.stop(true, true).slideDown(300);
//                     $box.addClass('active');
//                     $btn.text('Lees minder');
//                 }
//             }
//         });
//     });
// });





function displayFilter(){
    $('.collection-product__accordion-item').each(function () {
        const $title = $(this).find('.collection-product__accordion-title');
        const $content = $(this).find('.collection-product__accordion-content');
        if ($title.hasClass('active') || $content.hasClass('active')) {
            $title.addClass('active');
            $content.addClass('active').show();
        } else {
            $content.hide();
        }
    });
    $('.collection-product__accordion-title').on('click', function () {
        const $title = $(this);
        const $content = $title.next('.collection-product__accordion-content');
        $title.toggleClass('active');
        $content
            .toggleClass('active')
            .stop(true, true)
            .slideToggle(300);
    });
}
displayFilter();



if ($(Window).width() < 768) {
    $(document).on('click', '.collection-product__mobi-filter-btn', function (e) {
        $("body").addClass("collection-filter");
    });
    $(".collection-product__drawer-filter-close , .overlay").on("click", function () {
        $("body").removeClass("collection-filter");
    })
}




$(".header__cart").on("click", function () {
    $("body").addClass("cart-drawer-open");
})
$(".cart-drawer__close , .overlay").on("click", function () {
    $("body").removeClass("cart-drawer-open");
})

$(".header__search").on("click", function () {
    $("body").addClass("search-open");
})
$(".search__close, .overlay").on("click", function () {
    $("body").removeClass("search-open");
})

// $('.collection-product__drawer-form input[type="checkbox"]').on('change', function () {
//     $(this).closest('form').trigger('submit');
//   });









$(document).on(
  "change",
  ".collection-product__accordion input[type='checkbox']",
  function () {
    createCollectionFilterUrl();
  }
);

$(document).on(
  "click",
  ".collection-product__accordion-content-item-url",
  function (e) {
    e.preventDefault();

    $(".collection-product__accordion-content-item-url").removeClass("active");
    $(this).addClass("active");

    createCollectionFilterUrl($(this).attr("href"));
  }
);

$(document).on(
  "click",
  ".collection-product__topbar-dropdown-option a",
  function (e) {
    e.preventDefault();

    $(".collection-product__topbar-dropdown-option a").removeClass("active");
    $(this).addClass("active");

    createCollectionFilterUrl(null, $(this).attr("href"));
  }
);

function createCollectionFilterUrl(collectionUrl, sortUrl) {
  var selectedCollectionUrl =
    collectionUrl ||
    $(".collection-product__accordion-content-item-url.active").attr("href") ||
    window.location.pathname;

  var url = new URL(selectedCollectionUrl, window.location.origin);
  var params = new URLSearchParams();

  /*
   * Add all selected Shopify filters.
   *
   * Example:
   * filter.v.option.color=Black
   * filter.p.vendor=Vendor
   */
  $(".collection-product__accordion input[type='checkbox']:checked").each(
    function () {
      var filterName = $(this).attr("name");
      var filterValue = $(this).val();

      if (filterName && filterValue) {
        params.append(filterName, filterValue);
      }
    }
  );

  /*
   * Get sorting from the clicked sort URL,
   * otherwise use the currently active sort option.
   */
  var selectedSortUrl =
    sortUrl ||
    $(".collection-product__topbar-dropdown-option a.active").attr("href");

  if (selectedSortUrl) {
    var sortBy = new URL(
      selectedSortUrl,
      window.location.origin
    ).searchParams.get("sort_by");

    if (sortBy) {
      params.set("sort_by", sortBy);
    }
  }

  /*
   * Apply the rebuilt parameters to the selected collection URL.
   */
  url.search = params.toString();

  console.log("Filter-ready URL:", url.toString());
    window.history.replaceState({}, "", url.toString());
  fetch(url.toString())
        .then((res) => res.text())
        .then((data) => {
        var search__html = $(data);
        var render__html = $(".collection-product__wrapper", search__html);
        $(".collection-product__wrapper").replaceWith(render__html);

        displayFilter();

        singleScrollReveal(className = ".reveal-group", visibleOffset = 150, delay = 300);
        $(".scroll-animation").each(function () {
            observer.observe(this);
        });
        $(".fade-in-scroll").each(function () {
            observer2.observe(this);
        });
        });

  return url.toString();
}





// $(document).on('change', '.collection-product__accordion-content input', function () {
//     fetch(url + "&section_id=collection-grid")
//         .then((res) => res.text())
//         .then((data) => {
//         var search__html = $(data);
//         var render__html = $(".collection-product__items", search__html);
//         $(".collection-product__items").replaceWith(render__html);
//         });
//   });





  $(document).on("click", ".product__quan img:first-child", function () {
    var $input = $(this).siblings('input[name="quantity"]');
    var currentValue = parseInt($input.val()) || 1;
    var minValue = parseInt($input.attr("min")) || 1;

    if (currentValue > minValue) {
        $input.val(currentValue - 1).trigger("change");
    }
});

$(document).on("click", ".product__quan img:last-child", function () {
    var $input = $(this).siblings('input[name="quantity"]');
    var currentValue = parseInt($input.val()) || 1;

    $input.val(currentValue + 1).trigger("change");
});




$(document).on('click', '.collection-product__drawer-tag h5', function () {
    var removeUrl = $(this).data('remove-url');

    if (removeUrl) {
      window.history.pushState({}, '', removeUrl);

      
      
      fetch(removeUrl)
        .then((res) => res.text())
        .then((data) => {
        var search__html = $(data);
        var render__html = $(".collection-product__wrapper", search__html);
        $(".collection-product__wrapper").replaceWith(render__html);

        // var render__html = $(".collection-product__drawer-tag", search__html);
        // $(".collection-product__drawer-tag").replaceWith(render__html);

        // var render__html = $(".bread-crumbs", search__html);
        // $(".bread-crumbs").replaceWith(render__html);

        displayFilter();

        singleScrollReveal(className = ".reveal-group", visibleOffset = 150, delay = 300);
        $(".scroll-animation").each(function () {
            observer.observe(this);
        });
        $(".fade-in-scroll").each(function () {
            observer2.observe(this);
        });
        });
    }
  });




  $(window).on("load", function () {
  if (window.location.hash === "#ProductWaitlistForm" || window.location.hash === "#customer_form") {
    history.replaceState(null, null, window.location.pathname + window.location.search);
    window.scrollTo({
      top: 0,
      behavior: "instant"
    });
  }
});





// quantity validation
$(function () {
  var quantityValues = new Map();

  function trackDealEasyQuantity() {
    $('input[name^="items["][name$="[quantity]"]').each(function () {
      var input = this;
      var inputName = input.name;
      var currentValue = input.value;

      /*
       * Store the initial value when the input first appears.
       */
      if (!quantityValues.has(input)) {
        quantityValues.set(input, currentValue);
        console.log('Quantity input found:' + currentValue);
        console.log('remaining quantity = ' + remainingQuantity);
        if(currentValue > remainingQuantity){
            $('.product__delivery-items_notice').show();
            $('.product__delivery-items_notice .product__delivery-item strong').text(remainingQuantity);
            $('.product__btn-atc').addClass('btn_disabled');
            console.log('qty exit');
        }else{
            $('.product__delivery-items_notice').hide();
            $('.product__btn-atc').removeClass('btn_disabled');
            console.log('qty ok!!');
        }
        return;
      }
    //   if( productInventory >= currentValue){
    //     console.log('more');
    //   }

   
    });

    
  }

  
  setInterval(trackDealEasyQuantity, 150);
  trackDealEasyQuantity();
});

$('.lb-qty-selector-variant-quantity-input').each(function () {
    var input = this;

    new MutationObserver(function () {
        var max = parseInt(input.getAttribute('max'), 10);
        var min = parseInt(input.getAttribute('min'), 10) || 1;
        var value = parseInt(input.value, 10) || min;

        if (value > max) input.value = max;
        if (value < min) input.value = min;
    }).observe(input, {
        attributes: true,
        attributeFilter: ['value']
    });
});







  $(document).on('submit', '.form-awynidrhfx', function (event) {
    event.preventDefault();

    var $form = $(this);
    var $button = $form.find('button[type="submit"]');
    var $message = $form.find('.footer__newsletter-message');

    $button.prop('disabled', true);
    $message.text('Bezig met inschrijven...');

    fetch($form.attr('action'), {
      method: 'POST',
      body: new FormData(this)
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Submission failed');
        }

        $message.text('Bedankt! Je bent succesvol ingeschreven.');
        $form[0].reset();
      })
      .catch(function (error) {
        console.error(error);

        $message.text(
          'De inschrijving kon niet worden voltooid. Probeer het opnieuw.'
        );
      })
      .finally(function () {
        $button.prop('disabled', false);
      });
  });